<template>
  <div class="bbe-inset-link" v-click-outside="close" @click.stop>
    <label class="bbe-inset-link-label">
    <span class="bbe-inset-link-label__title">
              Text to display:
            </span>
      <input class="bbe-input bbe-input_border bbe-inset-link-label__input"
             @keyup.enter="insetLink"
             @keyup.esc="close"
             v-autofocus
             v-model="link.text"
             placeholder="Text"
             type="text"/>
    </label>
    <label class="bbe-inset-link-label">
      <span class="bbe-inset-link-label__title">
              Link to:
            </span>
      <input class="bbe-input bbe-input_border bbe-inset-link-label__input"
             @keyup.enter="insetLink"
             @keyup.esc="close"
             v-model="link.address"
             placeholder="http://"
             type="text"/>
    </label>
    <button class="bbe-button bbe-inset-link_button" @click.stop="insetLink">OK</button>
  </div>
</template>

<script>
export default {
  name: 'InsetLink',
  data () {
    return {
      link: {
        text: '',
        address: ''
      }
    }
  },
  methods: {
    insetLink () {
      if (!this.link.text || !this.link.address) {
        this.$emit('close')
        return
      }
      const a = document.createElement('a')
      a.href = this.link.address
      a.innerText = this.link.text
      this.$emit('insetLink', a)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbe-inset-link {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: $color-white;
    width: 200px;
    padding: 12px 12px;

    &-label {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin-bottom: 8px;

      &__title {
        text-align: left;
        display: inline;
        color: $color-silver-chalice;
        font-size: 12px;
        line-height: 14px;
        margin-bottom: 4px;
      }
    }

    &_button {
      padding: 0;
      min-width: 55px;
      width: 55px;
      height: 30px;
      font-size: 11px;
      margin-top: 8px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/TextEditor/InsetLink/InsetLink.vue